export const currencies = [
  { code: "ALL", sign: "Lek " },
  { code: "AFN", sign: "؋" },
  { code: "ARS", sign: "$" },
  { code: "AMD", sign: "֏" },
  { code: "AWG", sign: "ƒ" },
  { code: "AUD", sign: "$" },
  { code: "AZN", sign: "ман " },
  { code: "BSD", sign: "$" },
  { code: "BBD", sign: "$" },
  { code: "BYN", sign: "Br" },
  { code: "BZD", sign: "BZ$" },
  { code: "BMD", sign: "$" },
  { code: "BOB", sign: "$b" },
  { code: "BAM", sign: "KM" },
  { code: "BWP", sign: "P" },
  { code: "BGN", sign: "лв" },
  { code: "BRL", sign: "R$" },
  { code: "BND", sign: "$" },
  { code: "KHR", sign: "៛" },
  { code: "CAD", sign: "$" },
  { code: "KYD", sign: "$" },
  { code: "CLP", sign: "$" },
  { code: "CNY", sign: "¥" },
  { code: "COP", sign: "$" },
  { code: "CRC", sign: "₡" },
  { code: "HRK", sign: "kn" },
  { code: "CUP", sign: "₱" },
  { code: "CZK", sign: "Kč" },
  { code: "DKK", sign: "kr" },
  { code: "DOP", sign: "RD$" },
  { code: "XCD", sign: "$" },
  { code: "EGP", sign: "£" },
  { code: "SVC", sign: "$" },
  { code: "EUR", sign: "€" },
  { code: "FKP", sign: "£" },
  { code: "FJD", sign: "$" },
  { code: "GHS", sign: "¢" },
  { code: "GIP", sign: "£" },
  { code: "GTQ", sign: "Q" },
  { code: "GGP", sign: "£" },
  { code: "GYD", sign: "$" },
  { code: "HNL", sign: "L" },
  { code: "HKD", sign: "$" },
  { code: "HUF", sign: "Ft" },
  { code: "ISK", sign: "kr" },
  { code: "INR", sign: "₹" },
  { code: "IDR", sign: "Rp " },
  { code: "IRR", sign: "﷼" },
  { code: "IMP", sign: "£" },
  { code: "ILS", sign: "₪" },
  { code: "JMD", sign: "J$" },
  { code: "JPY", sign: "¥" },
  { code: "JEP", sign: "£" },
  { code: "KZT", sign: "лв " },
  { code: "KRW", sign: "₩" },
  { code: "KGS", sign: "лв " },
  { code: "LAK", sign: "₭" },
  { code: "LBP", sign: "£" },
  { code: "LRD", sign: "$" },
  { code: "MAD", sign: "DH" },
  { code: "MKD", sign: "ден " },
  { code: "MYR", sign: "RM" },
  { code: "MUR", sign: "₨" },
  { code: "MXN", sign: "$" },
  { code: "MNT", sign: "₮" },
  { code: "MZN", sign: "MT" },
  { code: "NAD", sign: "$" },
  { code: "NPR", sign: "₨" },
  { code: "ANG", sign: "ƒ" },
  { code: "NZD", sign: "$" },
  { code: "NIO", sign: "C$" },
  { code: "NGN", sign: "₦" },
  { code: "KPW", sign: "₩" },
  { code: "NOK", sign: "kr" },
  { code: "OMR", sign: "﷼" },
  { code: "PKR", sign: "₨" },
  { code: "PAB", sign: "B/." },
  { code: "PYG", sign: "Gs" },
  { code: "PEN", sign: "S/ " },
  { code: "PHP", sign: "₱" },
  { code: "PLN", sign: "zł" },
  { code: "QAR", sign: "﷼" },
  { code: "RON", sign: "lei " },
  { code: "RUB", sign: "₽" },
  { code: "SHP", sign: "£" },
  { code: "SAR", sign: "﷼" },
  { code: "RSD", sign: "Дин " },
  { code: "SCR", sign: "₨" },
  { code: "SGD", sign: "$" },
  { code: "SBD", sign: "$" },
  { code: "SOS", sign: "S" },
  { code: "ZAR", sign: "R" },
  { code: "LKR", sign: "₨" },
  { code: "SEK", sign: "kr " },
  { code: "CHF", sign: "CHF" },
  { code: "SRD", sign: "$" },
  { code: "SYP", sign: "£" },
  { code: "TWD", sign: "NT$" },
  { code: "THB", sign: "฿" },
  { code: "TTD", sign: "TT$" },
  { code: "TRY", sign: "₺" },
  { code: "TVD", sign: "$" },
  { code: "UAH", sign: "₴" },
  { code: "GBP", sign: "£" },
  { code: "USD", sign: "$" },
  { code: "UYU", sign: "$U" },
  { code: "UZS", sign: "лв " },
  { code: "VEF", sign: "Bs " },
  { code: "VND", sign: "₫" },
  { code: "YER", sign: "﷼" },
  { code: "ZWD", sign: "Z$" },
];
